import $ from "jquery";
import Chart from 'chart.js/auto';
import Sticky from 'sticky-js';

export default {
	init() {

		// *************** //
		// CALCULATOR PAGE //
		// *************** //
    
    //Get URL parameters
    var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

		// *** VISUAL STUFF *** //

		// sticky sidebar
		var sticky = new Sticky('.sticky-el');
		
		// set range color progress
		function setSliderColor($thisInput) {
			let thisValue = (($thisInput.val() - $thisInput.prop('min')) / ($thisInput.prop('max') - $thisInput.prop('min'))) * 100;
			
			$thisInput.css('background-image', 'linear-gradient(to right, #250144 0%, #250144 ' + thisValue + '%, #d3ccda ' + thisValue + '%, #d3ccda 100%');
		}

		// show the range input values
		function setOutputs($thisInput) {
			let thisInputID = $thisInput.attr('id'),
					$thisOutput = $thisInput.next('.input-result[data-output-for="' + thisInputID + '"]'),
					thisOutputFormatted = $thisInput.val().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

			$thisOutput.val(thisOutputFormatted); 
		}

		// if a user enters a val into the output field, update the input range slider to match
		function setInputs($thisOutput) {
			let thisOutputID = $thisOutput.data('output-for'),
					$thisInput = $thisOutput.prev('.input-range[id="' + thisOutputID + '"]'),
					thisOutputVal = $thisOutput.val(),
					thisOutputFormatted = thisOutputVal.replace(/,/g, '');

			$thisInput.val(thisOutputFormatted);
			setSliderColor($thisInput);
			$thisInput.trigger('input');
		}

		// *** CALCULATION STUFF *** //

		// set known values
		var ver_6_6 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: 0
		};
		var ver_6_7 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: 0
		};
		var ver_7_0 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: 0
		};
		var ver_7_1 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: 0
		};
		var ver_7_2 =  {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: 0
		};
		var ver_7_3 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: .025
		};
		var ver_7_4 = {
			lessFalsePos: 0,
			prioritizedAlerts: 0,
			fasterInvestigations: .15
		};
		var ver_7_5 = {
			lessFalsePos: .15,
			prioritizedAlerts: 0,
			fasterInvestigations: .15,
		};
		var ver_7_6 = {
			lessFalsePos: .15,
			prioritizedAlerts: 0,
			fasterInvestigations: .15,
		};
		var ver_8_0 = {
			lessFalsePos: .15,
			prioritizedAlerts: 0,
			fasterInvestigations: .175,
		};
		var ver_8_1 = {
			lessFalsePos: .15,
			prioritizedAlerts: .15,
			fasterInvestigations: .18,
		};
		var ver_8_2 = {
			lessFalsePos: .15,
			prioritizedAlerts: .15,
			fasterInvestigations: .175,
		};
		var ver_8_3 = {
			lessFalsePos: .175,
			prioritizedAlerts: .15,
			fasterInvestigations: .175,
		};
		var ver_8_4 = {
			lessFalsePos: .225,
			prioritizedAlerts: .15,
			fasterInvestigations: .175,
		};
		var ver_9_0 = {
			lessFalsePos: .225,
			prioritizedAlerts: .30,
			fasterInvestigations: .25,
		};

    
    // get the version improvement value
		// from the AML TM system dropdown
		// you can pass a metric as a string to retrieve a certain improvement metric
		// ex: getVersionImprovement('lessFalsePos');
		function getVersionImprovement(metric) {
			let version = $('#system-year').val(),
					version_reference = eval('ver_9_0');
      

			if (version) {
				version_reference = eval('ver_' + version.replace('.', '_'));
        
        
			}

			if (metric) {
				//console.log(version_reference[metric]);
				return(version_reference[metric]);
			} else {
				//console.log(version_reference);
				return(version_reference);
			}
		}

    
    
    
    
    
		// call this function any time an input is changed
		// we can call all calculations from here
    var upgraded_prioritized_alerts ='';
		function doCalculations() {      
      
      if($('.summary-outputs').length > 0) {
      let version_reference = eval('ver_9_0'),
          ver_9_0_lessFalsePos = version_reference.lessFalsePos,           
          ver_9_0_prioritizedAlerts = version_reference.prioritizedAlerts, 
          ver_9_0_fasterInvestigations = version_reference.fasterInvestigations,

          version_false_positive = eval( ver_9_0_lessFalsePos - (getVersionImprovement('lessFalsePos')) ),
          version_prioritized_alerts = eval( ver_9_0_prioritizedAlerts - (getVersionImprovement('prioritizedAlerts')) ),
          version_faster_investigations = eval( ver_9_0_fasterInvestigations - (getVersionImprovement('fasterInvestigations')) ),

          total_transactions = $('input[data-output-for="input-1"]').val().replace(/,/g, ''), 

          percentage_alerts = $('input[data-output-for="input-2"]').val(),  
          total_alerts = parseInt( (total_transactions) * (percentage_alerts / 100) ), 

          percentage_false_positives = $('input[data-output-for="input-3"]').val(),  
          total_false_positives = parseInt( (percentage_false_positives / 100) * (percentage_alerts / 100) * (total_transactions)  ),  

          percentage_l1_review = $('input[data-output-for="input-4"]').val(),            
          total_l1_review = parseInt( total_alerts * (percentage_l1_review / 100) ),  

          percentage_l2_review = $('input[data-output-for="input-5"]').val(),           
          total_l2_review = parseInt( total_alerts * (percentage_l2_review / 100) ),

          time_l1_review = $('input[data-output-for="input-6"]').val(),
          time_l2_review = $('input[data-output-for="input-7"]').val(),

          salary_l1 = $('input[data-output-for="input-8"]').val().replace(/,/g, ''), 
          salary_l2 = $('input[data-output-for="input-9"]').val().replace(/,/g, ''),

          cost_per_min_l1 = eval( (salary_l1 * 1.4) / (222 * 8) / 60),
          cost_per_min_l2 = eval( (salary_l2 * 1.4) / (222 * 8) / 60),

          base_li_inv = eval(total_l1_review * (percentage_false_positives / 100)),
          upgraded_prioritized_alerts = eval( (base_li_inv) * ( 1 - version_prioritized_alerts ) ),
          upgraded_investigations_l1 = eval( base_li_inv - upgraded_prioritized_alerts),          

          future_false_positives =  eval( total_false_positives * (version_false_positive) ),
          reduction_false_positives = eval( total_false_positives - future_false_positives), 

          reduction_review = eval( (future_false_positives) * (percentage_l1_review / 100) ),  
          upgraded_false_positives = eval( (base_li_inv) - reduction_review ), 

          final_total_l1 = eval(total_l1_review - (reduction_review + upgraded_investigations_l1)),
          final_total_l2 = eval(final_total_l1 * (percentage_l2_review / 100) ),

          final_total_l1_investigation_time = eval(time_l1_review * (1 - version_faster_investigations) ),
          final_total_l2_investigation_time = eval(time_l2_review * (1 - version_faster_investigations) ),

          calculation_faster_investigations_l1 = eval( (time_l1_review - final_total_l1_investigation_time) * total_alerts / time_l1_review),
          calculation_faster_investigations_l2 = eval( (time_l2_review - final_total_l2_investigation_time) * total_l2_review / time_l2_review),
          calculation_faster_investigations_l1_inv = eval( (time_l1_review - final_total_l1_investigation_time) * total_l1_review / time_l1_review ),
          calculation_faster_investigations_l2_inv = eval( (time_l2_review - final_total_l2_investigation_time) * (total_l1_review * (percentage_l2_review / 100)) / time_l2_review ),

          final_reduced_hours_l1 = eval( reduction_review * time_l1_review / 60 ), //
          final_priotized_alerts_l1 = eval( upgraded_investigations_l1 * time_l1_review / 60 ),
          final_faster_investigations_l1 = eval( calculation_faster_investigations_l1_inv * time_l1_review / 60 ),
          final_faster_investigations_l2 = eval(  calculation_faster_investigations_l2_inv * time_l2_review / 60 ),

          combined_hours = eval( parseInt(final_faster_investigations_l1) + parseInt(final_faster_investigations_l2) ),

          final_reduced_currency_less_false_positives = eval( (final_reduced_hours_l1 * 60 * cost_per_min_l1) + (0 * 60 * cost_per_min_l2) ),
          final_reduced_currency_prioritized_alerts = eval( (final_priotized_alerts_l1 * 60 * cost_per_min_l1 ) + (0 * 60 * cost_per_min_l2) ),
          final_reduced_currency_faster_investigations = eval( (final_faster_investigations_l1 * 60 * cost_per_min_l1) + (final_faster_investigations_l2 * 60 * cost_per_min_l2) ),
        
					total_savings_result = eval(final_reduced_currency_less_false_positives + final_reduced_currency_prioritized_alerts + final_reduced_currency_faster_investigations);
					// if total savings is $1bn or greater, reduce font size of result to fit in overview container
					if (total_savings_result > 99999999999) {
						$('#total-savings-result .total').addClass('one-tril');
					} else if (total_savings_result > 999999999) {
						$('#total-savings-result .total').addClass('one-bil');
					}
					if (total_savings_result <= 999999999 && $('#total-savings-result .total').hasClass('one-bil')) {
						$('#total-savings-result .total').removeClass('one-bil');
					} else if (total_savings_result <= 99999999999 && $('#total-savings-result .total').hasClass('one-tril')) {
						$('#total-savings-result .total').removeClass('one-tril');
					}

      $('#reduce-false-positives-result .time').text(final_reduced_hours_l1.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
      $('#reduce-false-positives-result .cost').text(final_reduced_currency_less_false_positives.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));  


      $('#reduce-manual-burden-result .time').text(final_priotized_alerts_l1.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
      $('#reduce-manual-burden-result .cost').text(final_reduced_currency_prioritized_alerts.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));

      $('#increasing-speed-result .time').text(combined_hours.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
      $('#increasing-speed-result .cost').text(final_reduced_currency_faster_investigations.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')); 

      $('#total-savings-result .total').text('$' + total_savings_result.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')); 
        
      //populate hidden field
        var total_savings = '$' + total_savings_result.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        var system_year = $('#system-year').val();
        var current_url = window.location.href;
        var reduced_false_positives = final_reduced_currency_less_false_positives.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,').replace(/,/g, '');
        var alert_prioritization = final_reduced_currency_prioritized_alerts.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,').replace(/,/g, '');
        var faster_investigations = final_reduced_currency_faster_investigations.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,').replace(/,/g, ''); 
        $('.hs_roi_calculator_result input').val(current_url + '?results=true&total-savings='+total_savings+'&transactions-per-year='+total_transactions+'&percentage-alert='+percentage_alerts+'&percentage-false-positive='+percentage_false_positives+'&percentage-l1='+percentage_l1_review+'&percentage-l2='+percentage_l1_review+'&l1-time='+time_l1_review+'&l2-time='+time_l2_review+'&l1-salary='+salary_l1+'&l2-salary='+salary_l2+'&purchase-year='+system_year+'&faster-investigations='+faster_investigations+'&alert-prioritization='+alert_prioritization+'&fewer-false-positives='+reduced_false_positives);

        
      console.log('total_alerts: ' + total_alerts);
      console.log('total_false_positives: ' + total_false_positives);      
      console.log('total_l1_review: ' + total_l1_review);
      console.log('total_l2_review: ' + total_l2_review);
      console.log('____________________');    
      console.log('version_false_positive: ' + version_false_positive);
      console.log('version_prioritized_alerts: ' + version_prioritized_alerts);
      console.log('version_faster_investigations: ' + version_faster_investigations);
      console.log('____________________');      
      console.log('reduction_review: ' + reduction_review);
      console.log('reduction_false_positives: ' + reduction_false_positives);
      console.log('future_false_positives: ' + future_false_positives);
      console.log('upgraded_false_positives: ' + upgraded_false_positives);
      console.log('upgraded_prioritized_alerts: ' + upgraded_prioritized_alerts);      
      console.log('upgraded_investigations_l1: ' + upgraded_investigations_l1);  
      console.log('____________________');      
      console.log('final_total_l1: ' + final_total_l1);  
      console.log('final_total_l2: ' + final_total_l2);
      console.log('____________________');      
      console.log('final_total_l1_investigation_time: ' + final_total_l1_investigation_time);  
      console.log('final_total_l2_investigation_time: ' + final_total_l2_investigation_time);  
      console.log('____________________');      
      console.log('final_reduced_hours_l1: ' + final_reduced_hours_l1);  
      console.log('final_priotized_alerts_l1: ' + final_priotized_alerts_l1); 
      console.log('calculation_faster_investigations_l1: ' + calculation_faster_investigations_l1); 
      console.log('calculation_faster_investigations_l2: ' + calculation_faster_investigations_l2); 
      console.log('final_faster_investigations_l1: ' + final_faster_investigations_l1); 
      console.log('final_faster_investigations_l2: ' + final_faster_investigations_l2); 
      console.log('____________________');      
      console.log('final_reduced_currency_less_false_positives: ' + final_reduced_currency_less_false_positives);  
      console.log('final_reduced_currency_prioritized_alerts: ' + final_reduced_currency_prioritized_alerts);  
      console.log('final_reduced_currency_faster_investigations: ' + final_reduced_currency_faster_investigations);
      }
		}

		// set listeners for range inputs 
		$('.input-range').each(function () {
			setOutputs($(this));
      setSliderColor($(this));

			$(this).on('input', function () {
				setOutputs($(this));
				setSliderColor($(this));
				doCalculations();
			});
		});

		// set listeners for range outputs (the text field next to each range slider)
		$('.input-result').on('change', function() {
			setInputs($(this));
		});

		// set listener for select input
		$('.input-select').on('change', function () {
			doCalculations();
		});

		// set initial output vals
		doCalculations();


		// -------------------------------------------------------------------- //


		// ************ //
		// RESULTS PAGE
		// ************ //

		// colors
		var purple = 'rgba(169, 51, 251, .9)',
				orange = 'rgba(255, 133, 0, .9)',
				blue = 'rgba(0, 116, 232, .9)';

		// vals from url params
		var transactionsPerYear = $('#transactions-per-year').data('val'),
				percentageAlert = $('#percentage-alert').data('val'),
				percentageFalsePositive = $('#percentage-false-positive').data('val'),
				percentageL1 = $('#percentage-l1').data('val'),
				percentageL2 = $('#percentage-l2').data('val'),
				l1Time = $('#l1-time').data('val'),
				l2Time = $('#l2-time').data('val'),
				l1Salary = $('#l1-salary').data('val'),
				l2Salary = $('#l2-salary').data('val'),
				purchaseYear = $('#purchase-year').data('val');


		// * resources saved / year * //
		function resourcesPerYear() { 

			const labels = ["Total", "Faster investigation", "Alert prioritization", "Fewer false positives"],
						// sample values for savings 
						fasterInvestigation = getUrlParameter('faster-investigations'),
						alertPrioritization = getUrlParameter('alert-prioritization'),
						fewerFalsePositives = getUrlParameter('fewer-false-positives'),
						totalSavings = fasterInvestigation + alertPrioritization + fewerFalsePositives,
						// each array index in the dataset corresponds to a bar in the graph (left to right)
						fasterInvestigationDataset = [fasterInvestigation, fasterInvestigation, 0, 0],
						alertPrioritizationDataset = [alertPrioritization, 0, alertPrioritization, 0],
						fewerFalsePositivesDataset = [fewerFalsePositives, 0, 0, fewerFalsePositives];
		
			new Chart(document.getElementById('resources-per-year'), {
				type: 'bar',
				options: {
					scales: {
						x: {
							grid: {
								display: false,
							}
						},
						y: {
							stacked: true,
							border: {
								display: false,
							},
							ticks: {
								callback: function(value, index, ticks) {
									// return formatted '$' + value;
									return "$" + parseInt(value).toLocaleString();
								}
							}
						}
					}
				},
				data: {
					labels: labels,
					datasets: [
						{
							label: 'Faster investigation',
							data: fasterInvestigationDataset,
							maxBarThickness: 100,
							backgroundColor: orange,
							stack: 'bar',
							order: 1,
						},
						{
							label: 'Alert prioritization',
							data: alertPrioritizationDataset,
							maxBarThickness: 100,
							backgroundColor: blue,
							stack: 'bar',
							order: 2,
						},
						{
							label: 'Fewer false positives',
							data: fewerFalsePositivesDataset,
							maxBarThickness: 100,
							backgroundColor: purple,
							stack: 'bar',
							order: 3,
						}
					]
				}
			});
		}


		// * reduceFalsePositives * //
		function reduceFalsePositives() {
			const labels = [0, 50, 100];

			new Chart(document.getElementById('reduce-false-positives'), {
				responsive: true,
				data: {
					datasets: [{
						type: 'bar',
						data: [0, 10, 0],
						maxBarThickness: 100,
						backgroundColor: purple,
						order: 2,
					}, {
						type: 'line',
						data: [20, 8, 5],
						backgroundColor: blue,
						order: 1
					}],
					labels: labels,
				},
				options: {
					scales: {
						x: {
							grid: {
								display: false,
							},
							title: {
								display: true,
								text: 'Cost',
							},
							ticks: {
								display: false,
							}
						},
						y: {
							title: {
								display: true,
								text: 'Time',
							},
							border: {
								display: false,
							},
							ticks: {
								display: false,
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		}


		// * reduceManualReviews * //
		function reduceManualReviews() {
			const labels = [0, 50, 100]

			new Chart(document.getElementById('reduce-manual-reviews'), {
				responsive: true,
				data: {
					datasets: [{
						type: 'bar',
						data: [0, 15, 0],
						maxBarThickness: 100,
						backgroundColor: purple,
						order: 2,
					}, {
						type: 'line',
						data: [25, 20, 7],
						backgroundColor: blue,
						order: 1
					}],
					labels: labels,
				},
				options: {
					scales: {
						x: {
							grid: {
								display: false,
							},
							title: {
								display: true,
								text: 'Cost',
							},
							ticks: {
								display: false,
							}
						},
						y: {
							title: {
								display: true,
								text: 'Time',
							},
							border: {
								display: false,
							},
							ticks: {
								display: false,
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		}


		// * increaseSpeed * //
		function increaseSpeed() {
			const labels = [0, 50, 100];

			new Chart(document.getElementById('increase-speed'), {
				responsive: true,
				data: {
					datasets: [{
						type: 'bar',
						data: [0, 30, 0],
						maxBarThickness: 100,
						backgroundColor: purple,
						order: 2,
					}, {
						type: 'line',
						data: [11, 5, 3],
						backgroundColor: blue,
						order: 1
					}],
					labels: labels,
				},
				options: {
					scales: {
						x: {
							grid: {
								display: false,
							},
							title: {
								display: true,
								text: 'Cost',
							},
							ticks: {
								display: false,
							}
						},
						y: {
							title: {
								display: true,
								text: 'Time',
							},
							border: {
								display: false,
							},
							ticks: {
								display: false,
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		}


		// if on the results screen, run chart.js
		let urlParams = new URLSearchParams(window.location.search),
				results = urlParams.get('results');

		if (results) {
			resourcesPerYear();
			reduceFalsePositives();
			reduceManualReviews();
			increaseSpeed();
		}
	},
	finalize() {},
};
